export default "__VITE_ASSET__CBZKZDVR__"